/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF, CurrencyPipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpInterceptorFn, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { CacheInterceptor } from './@core/interceptors/cache.interceptor';
import { CoreModule } from './@core/core.module';
import { UserStateService } from './@core/service/user-state.service';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {MultiselectDropdownModule} from 'angular-2-dropdown-multiselect';
import {SidebarModule} from 'ng-sidebar';
import {UiSwitchModule} from 'ngx-ui-switch';
import {NgxPaginationModule} from 'ngx-pagination';
import {AUTH_CONFIG} from './@core/config/auth.config';
import {NbAuthModule} from '@nebular/auth';
import {AuthGuardService} from './@core/service/auth-guard.service';
import {ApiService} from './@core/service/api.service';
import {NbAlertModule, NbDatepickerModule, NbInputModule, NbPopoverDirective, NbPopoverModule, NbToastrService} from '@nebular/theme';
import localeDe from '@angular/common/locales/de';
import { PendingChangesGuard } from './@core/service/pending-changes-guard.service';
import { SocketService } from './@core/service/socket.service';
import { RoleGuardService } from './@core/service/role-guard.service';
import { NbAuthPatchComponent } from './auth/NbAuthPatch.component';
import { NbLoginPatchComponent } from './auth/login/login-patch.component';
import { NbLogoutPatchComponent } from './auth/NbLogoutPatch.component';
import { CookieModule } from 'ngx-cookie';
import { TreeService } from './@core/service/tree.service';
import { SharedDataService } from './@core/service/shared-data.service';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { ErrorService } from './@core/service/error.service';
import Quill from 'quill';
import BlotFormatter from 'quill-blot-formatter';
import QuillTableBetter from 'quill-table-better';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { PopupModule } from './popup/popup.module';
import { DialogWizardService } from './pages/erp/shared/dialog-wizard/dialog-wizard.service';
import { CustomDateParserFormatter } from './pages/erp/shared/doc-form-date/date-parser-formatter';

registerLocaleData(localeDe, 'de');
Quill.register('modules/blotFormatter', BlotFormatter);
Quill.register({'modules/table-better': QuillTableBetter}, true);


// export const HttpLogInterceptor: HttpInterceptorFn = (req, next) => {
//   console.log('http interceptor log', req, next, next(req));
//   return next(req);
// }

@NgModule({
  declarations: [
    AppComponent,
    NbAuthPatchComponent,
    NbLoginPatchComponent,
    NbLogoutPatchComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    // HttpClientModule,
    Ng2SmartTableModule,
    MultiselectDropdownModule,
    AppRoutingModule,
    SidebarModule,
    UiSwitchModule,
    NgxPaginationModule,
    NgbModule,
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NbEvaIconsModule,
    NbAuthModule.forRoot(AUTH_CONFIG),
    NbDatepickerModule.forRoot(),
    NbAlertModule,
    NbInputModule,
    CookieModule.withOptions(),
    FormsModule,
    QuillModule.forRoot(),
    PopupModule,
  ],
  bootstrap: [AppComponent],
providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
        DecimalPipe,
        CurrencyPipe,
        ApiService,
        CacheInterceptor,
        UserStateService,
        TreeService,
        SharedDataService,
        AuthGuardService,
        RoleGuardService,
        NbToastrService,
        PendingChangesGuard,
        SocketService,
        DialogWizardService,
        // provideHttpClient(withInterceptorsFromDi(), withInterceptors([HttpLogInterceptor])),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useExisting: CacheInterceptor, multi: true },
        { provide: ErrorHandler, useClass: ErrorService },
    ],
})
export class AppModule {
}
